<template>
  <div class="stepper-container">
    <div class="line-behind" :style="lineStyle"></div>
    <div class="line-progress" :style="progressStyle"></div>

    <div class="stepper-content">
      <div
        v-for="(stepLabel, index) in steps"
        :key="index"
        class="step"
        
      >
        <div
          class="circle-wrapper"
          :class="{
            active: index === currentStep,
            completed: index < currentStep
          }"
        >
          <template v-if="index < currentStep">
            <svg class="check-icon" viewBox="0 0 24 24">
              <path
                fill="white"
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
              />
            </svg>
          </template>
          <template v-else-if="index !== currentStep">
            <div class="circle-inner"></div>
          </template>
        </div>
        <div
          class="label"
          :class="{
            active: index === currentStep,
            completed: index < currentStep
          }"
        >
          {{ stepLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => ["Step 1", "Step 2", "Step 3"],
    },
  },
  computed: {
  
    lineStyle() {
      const total = this.steps.length;
      const offset = 100 / (total * 2); 
      return {
        left: `${offset}%`,
        right: `${offset}%`,
      };
    },
   
    progressStyle() {
      const total = this.steps.length;
      const offset = 100 / (total * 2);
      const width = (this.currentStep / (total - 1)) * (100 - 2 * offset);
      return {
        left: `${offset}%`,
        width: `${width}%`,
      };
    },
  },
  methods: {
    setActive(index) {
      this.$emit("update:currentStep", index);
    },
  },
};
</script>

<style scoped>
.stepper-container {
  position: relative;
  margin: 40px auto;
  max-width: 100%;
  width: 60rem;
  height: 60px;
  user-select: none;
}


.line-behind {
  position: absolute;
  top: 16px;
  height: 2px;
  background-color: #e0e0e0;
  z-index: 0;
}


.line-progress {
  position: absolute;
  top: 16px;
  height: 2px;
  background-color: #207878;
  z-index: 1;
  transition: width 0.3s ease;
}


.stepper-content {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  padding: 0 12px;
}


.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 0;
  cursor: pointer;
}

.circle-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.circle-wrapper.active {
  background-color: white;
  border: 6px solid #207878;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
}

.circle-wrapper.completed {
  background-color: #207878;
}

.circle-inner {
  width: 16px;
  height: 16px;
  background-color: #bdbdbd;
  border-radius: 50%;
}

.check-icon {
  width: 20px;
  height: 20px;
  fill: white;
}


.label {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  text-align: center;
  transition: color 0.3s;
}

.label.active {
  font-size: 18px;
  color: #207878;
  font-weight: 600;
}

.label.completed {
  color: #207878;
  font-weight: 600;
}
</style>
